{
  "cancel": {},
  "run": {},
  "fail": {
    "back": {},
    "cancel": {},
    "tryAgain": {}
  },
  "success": {
    "close": {}
  }
}
